import React from "react";
import "./faq.css";

const FAQ = () => {
  const faqs = [
    {
      question: "Where to register a new participant?",
      answer:
        'There is a link of “Registration” on the main page of the CPD-SHALAMAR. Click <a href="/signup">here</a> to register as a new participant.',
    },
    {
      question:
        "I heard there will be many events in the CPD-SHALAMAR. Is there a separate fee for every events?",
      answer: "Yes",
    },
    {
      question: "Is there a limit of Event participants?",
      answer:
        "Yes, every Event has limited seats. The website will guide when the seats are full. However, you may contact the registration office in case of further queries.",
    },
    { question: "What is the refund policy?", answer: "NA" },
    {
      question: "Will you provide accommodation or traveling arrangements?",
      answer: "NA",
    },
    {
      question: "Where is the location of the Event?",
      answer: `The conference will be held at “Shalamar Medical & Dental College” situated on “Shalimar Link Road, Lahore PAKISTAN”. 
      You may get the map from Google Maps <a href="https://www.google.com/maps/dir/%27%27/shalamar+medical+and+dental+college/@31.575819,74.309516,12z/data=!3m1!4b1!4m8!4m7!1m0!1m5!1m1!1s0x39191ac8f8b96991:0x8e4fbb1f7e6e1c0e!2m2!1d74.3795562!2d31.5758381" target="_blank" rel="noopener noreferrer">here</a>.`,
    },
    {
      question: "What are the dates of the Events?",
      answer:
        'You may get a detailed program from <a href="/program">here</a>.',
    },
    {
      question:
        "What is the history of Lahore? Are there any significant places to visit or roam around?",
      answer:
        'Lahore is a historical city rich in culture. There are many historical places from the Mughal era. Lahore is famous for its beautiful parks, gardens, and delicious food. You\'ll find Food Streets in Lahore as well. More information about Lahore can be found here: <br/> <a href="https://www.punjab.gov.pk/lahore" target="_blank" rel="noopener noreferrer">Punjab Government</a> | <a href="https://www.facebook.com/lahore.gardens/" target="_blank" rel="noopener noreferrer">Lahore Gardens Facebook Page</a>.',
    },
  ];

  return (
    <div className="faq-container">
      <h1>FAQ</h1>
      {faqs.map((faq, index) => (
        <div className="faq-item" key={index}>
          <h3 className="faq-question">{faq.question}</h3>
          <p
            className="faq-answer"
            dangerouslySetInnerHTML={{ __html: faq.answer }}
          ></p>
        </div>
      ))}
    </div>
  );
};

export default FAQ;
